// extracted by mini-css-extract-plugin
export var courseWrapper = "course-card-module--courseWrapper--jNpFc";
export var cardOverlay = "course-card-module--cardOverlay--rVfS0";
export var imageWrapper = "course-card-module--imageWrapper--Udqq4";
export var courseName = "course-card-module--courseName--wi0YD";
export var image = "course-card-module--image--zB0FB";